import { useParams } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CatalogSessionsDataTable } from 'modules/trainings/components/CatalogComponent/CatalogSessionsDataTable'
import { useTrainingsContext } from 'modules/trainings/hooks/Trainings/useTrainingsContext'

import { AttendanceTag } from '../MyTrainingsDatatable/AttendanceTag'
import { Competencies } from './Competencies'
import { Description } from './Description'
import { SessionsDataTable } from './SessionsDatatable'
import { MyTrainingFiles } from './TrainingFiles'

interface Props {
  accessId: number
  fileNavigation: (fileId: string) => string | undefined
  sessionModalTo: (sessionId: string | number) => string
  uploadCertificateTo: (trainingId: string | number) => string
  restrictedNavigation?: boolean
}
export const Detail = ({
  fileNavigation,
  accessId,
  sessionModalTo,
  uploadCertificateTo,
  restrictedNavigation = false,
}: Props) => {
  const { trainingId } = useParams()
  const { trainings } = useTrainingsContext()
  const training = trainings.find((t) => t.id === Number(trainingId))

  if (!training) return null

  const Component = restrictedNavigation ? CatalogSessionsDataTable : SessionsDataTable

  return (
    <Box gap="s48">
      <Box gap="s16">
        <Box alignItems="flexStart">
          <AttendanceTag trainingId={training.id} accessId={accessId} />
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box gap="s8">
            <Text.Header1>{training.name}</Text.Header1>
            <Description trainingDescription={training.description} />
          </Box>
          <Competencies competencies={training.competencies} />
        </Box>
      </Box>
      <Box gap="s32">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Header2>{i18n.t('trainings.my_training.attached_files')}</Text.Header2>
          {!restrictedNavigation && (
            <Button.Router
              to={uploadCertificateTo(training.id)}
              type="secondary"
              iconName="upload"
            />
          )}
        </Box>
        <MyTrainingFiles
          fileNavigation={fileNavigation}
          restrictedNavigation={restrictedNavigation}
          accessId={accessId}
        />
      </Box>
      <Box gap="s32">
        <Text.Header2>{i18n.t('trainings.my_training.sessions_groups')}</Text.Header2>
        <Component trainingId={training.id} accessId={accessId} sessionModalTo={sessionModalTo} />
      </Box>
    </Box>
  )
}
